/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { ViewerSourceCreator } from '../viewer/source'
 * @import ViewerControllerVideoFactory from '../viewer/controller/viewer-controller-video-factory'
 * @import WebosSignage3_0StreamViewerControllerFactory from '../webos-signage-3.0/stream/webos-signage-3.0-stream-viewer-controller-factory'
 * @import { ViewerType } from '../viewer/type'
 */

/**
 * Typ média video stream.
 * Používá se pouze URL ze serveru bez podpory offline stavu.
 * @implements {ViewerType}
 */
export default class StreamViewerType {
  // TODO #555: Co to je za anti-pattern, že závislost není jako rozhraní, ale neSOLIDně dvě nějaké implementace?
  // Správně by mělo vzniknout rozhraní a minimálně tyto dvě implementace ho implementovat.
  /**
   * Vytvoří instanci.
   * @param {Pick<ViewerControllerVideoFactory | WebosSignage3_0StreamViewerControllerFactory, 'create'>} controllerFactory
   * @param {ViewerSourceCreator<HTMLVideoElement>} sourceCreator
   */
  constructor(controllerFactory, sourceCreator) {
    // TODO Lepší organizace Viewer modulu.
    // - Zde by se hodilo mít inteface VideoViewerControllerFactory.
    // - Zatím řešeno jako výčet typů a zde se spoléhá na stejné parametry u create,
    //   což není úplně vhodné.
    // - Také by měl existovat VideoViewerSourceCreator a ne jen obecné rozhraní.
    this.controllerFactory = controllerFactory;
    this.sourceCreator = sourceCreator;
  }

  /** @type {ViewerType['createController']} */
  createController(el, communicatorSettingsGetter) {
    return this.controllerFactory.create(el, communicatorSettingsGetter);
  }

  /** @type {ViewerType['getCheckFile']} */
  getCheckFile(medium) {
    // Streamy nemají v detailu média nastavení "Kontrolovat aktuální verzi".
    return false;
  }

  /** @type {ViewerType['getSourceCreator']} */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @type {ViewerType['getUrl']} */
  async getUrl(medium) {
    return await medium.url;
  }

  /** @type {ViewerType['isExtractable']} */
  isExtractable() {
    return false;
  }

  /** @type {ViewerType['isOfflineable']} */
  isOfflineable() {
    return false;
  }

  /** @type {ViewerType['isPreloadable']} */
  isPreloadable(medium) {
    return true;
  }

  /** @type {ViewerType['isSeekable']} */
  isSeekable(medium) {
    return false;
  }

  /** @type {ViewerType['isStatic']} */
  isStatic(medium) {
    return true;
  }
}
